import { Controller } from "@hotwired/stimulus";

// Connects to data-controller='categories--admin--review-gifts--recurring-gift-radio'
//
// Keeps the "Enter in Existing Recurring Gift ID" input required only while that option is
// actually selected, and never while the fieldset is disabled by another unresolved error.
//
// This has to stay scoped to its own panel. The review page renders one modal per gift, so a
// document-wide lookup makes every gift on the page follow the *first* gift's radio state —
// which left "Create new Recurring Gift in RE NXT" unsubmittable on every row but the first.
export default class extends Controller {
  static targets = ["fieldset", "existingRadio", "externalIdentifier"];

  connect() {
    this.updateRequired();
  }

  updateRequired() {
    const enabled = !this.fieldsetTarget.disabled;

    this.existingRadioTarget.required = enabled;
    this.externalIdentifierTarget.required = enabled && this.existingRadioTarget.checked;
  }
}
